import { Action, createReducer, on } from '@ngrx/store'
import { KnowledgeState, initialKnowledgeState } from '../state/knowledge.state'
import {
  LOAD_KNOWLEDGE_SUMMARY_DETAILS_SUCCESS,
  load_knowledge_quick_option_details_success,
  search_knowledge_success_action,
  view_knowledge_success_action
} from '../action/knowledge.action'
export function knowledgeReducer(state: KnowledgeState, action: Action) {
  return _knowledgeReducer(state, action)
}

export const _knowledgeReducer = createReducer(
  initialKnowledgeState,
  on(search_knowledge_success_action, (state, { knowledge }) => {
    return {
      ...state,
      search: knowledge
    }
  }),
  on(view_knowledge_success_action, (state, { knowledge }) => {
    return {
      ...state,
      details: knowledge
    }
  }),
  on(LOAD_KNOWLEDGE_SUMMARY_DETAILS_SUCCESS, (state, { knowledge }) => {
    return {
      ...state,
      search: knowledge
    }
  }),
  on(load_knowledge_quick_option_details_success, (state, { knowledge }) => {
    return {
      ...state,
      quickViewList: knowledge
    }
  })
)
